import React, { useEffect } from 'react'
import { BCEntityBase } from '../models/shared/BCEntityBase';
import { azureGetItems } from '../utils/api';
import { useAuth } from 'reactfire';
import { toast } from 'react-toastify';
import { Spinner } from 'react-bootstrap';

interface Props {
    companyId: string
    itemId: string
    onChange: (itemId: string) => void
}

export default function AzureItemPicker({ companyId, itemId, onChange }: Props) {
    const [candidates, setCandidates] = React.useState<BCEntityBase[]>([]);
    const [processing, setProcessing] = React.useState(false);
    const { currentUser } = useAuth();

    useEffect(() => {
        if (!companyId) {
            setCandidates([]);
            return;
        }
        const fetchCandidates = async () => {
            setProcessing(true);

            try {
                const token = await currentUser?.getIdToken();
                const candidates = await azureGetItems(token, companyId);
                setCandidates(candidates);
            } catch (error) {
                console.error('Failed to fetch Azure items:', error);
                toast.error('Failed to fetch Azure items. Please try again later.');
            }
            setProcessing(false);
        }

        fetchCandidates();
    }, [companyId, currentUser])


    return (
        <div>
            <div>
                <label>Select BC Item</label>
                {processing && <Spinner animation="border" size="sm" className='ms-2' />}
            </div>
            <select className='form-select' value={itemId || ''} onChange={(e) => onChange(e.target.value)}
                disabled={processing || candidates.length === 0}
            >
                <option value=''>Select an item</option>
                {candidates.map(item => (
                    <option key={item.id} value={item.id}>{item.name}</option>
                ))}
            </select>

        </div>
    )
}
